import { safeJsonParse } from "@/lib/safeJsonParse";
import Editor from "./read-only-editor";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

export default function EventDescription({ event, className }: any) {
  const t = useTranslations("General");

  return (
    <div className={cn(className, "space-y-2 max-w-full my-2")}>
        <Editor value={safeJsonParse(event.description)} />
    </div>
  );
}
